import axios from "axios";
import React, { useEffect, useContext } from "react";
import { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../src/WebPages/Home.css";
import ReactGA from "react-ga4";
import UserContext from "./context/UserContext";
import common_axios from "./Services/commonAxios";
import { useRef } from "react";

function Splash() {
  const { update, updateCartCount } = useContext(UserContext);
  const nav = useNavigate();
  let { session_token, page } = useParams();
  const [progress, setProgress] = useState(0);
  const check = "Y";
  const [isFaug, setIsFaug] = useState("N");
  const clearedRef = useRef(false);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await common_axios.get(
          `/store_user/credential?session_token=${session_token}`
        );
        const token = resp.data.data;
        setIsFaug(resp.data.isFaug);
        const redirect = resp.data.redirect;

        // Store method and country from credentials response for bottomLogin
        if (resp.data.method) {
          localStorage.setItem("loginMethod", resp.data.method);
        }
        if (resp.data.country) {
          localStorage.setItem("userCountry", resp.data.country);
        }
        if (resp.data.alreadyRegistered !== undefined) {
          localStorage.setItem(
            "alreadyRegistered",
            resp.data.alreadyRegistered
          );
        }

        // Prevent infinite loop by tracking localStorage clear
        if (resp.data.shouldClearLocalStorage === "Y") {
          localStorage.clear();
          localStorage.setItem("clearedOnce", "true");

          await common_axios.get(
            `/store_user/credential_clear?session_token=${session_token}`
          );
        }

        if (token === "undefined" || !token) {
          return nav("/404");
        }

        ReactGA.set({ userId: session_token });

        if (localStorage.getItem("auth")) {
          localStorage.setItem("session_token", token);
        } else {
          localStorage.setItem("token", token);
          localStorage.setItem("session_token", token);
        }

        update(token);
        updateCartCount();

        const timer = setInterval(() => {
          setProgress((oldProgress) => {
            if (oldProgress === 100) {
              clearInterval(timer);
            }
            const diff = Math.random() * 8;
            return Math.min(oldProgress + diff, 100);
          });
        }, 50);

        const queryParams = new URLSearchParams(location.search);
        let page = queryParams.get("page");
        for (const [key, value] of queryParams.entries()) {
          console.log(`${key} = ${value}`);
        }

        setTimeout(() => {
          if (redirect === "winnerForm") {
            nav("/winnerForm?page=detail", { replace: true });
          } else if (page === "refer") {
            nav("/refer", { replace: true });
          } else if (page === "chakra") {
            nav("/rewards-chakra", { replace: true });
          } else if (isFaug === "N") {
            nav("/home", { replace: true });
          } else {
            nav("/home", { replace: true });
          }
        }, 1000);
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchData();
  }, [session_token]);

  return (
    <main className="loading-main">
      <img src="/assets/images/icespice-logo.png" alt="IceSpice Logo" />
      <div className="loading-bars">
        <div className="loading-bar" style={{ width: `${progress}%` }} />
      </div>
      <div className="circleblur1" />
    </main>
  );
}

export default Splash;
